// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  DefaultResponseError,
  DefaultResponseErrorFromJSON,
  DefaultResponseErrorToJSON,
  ExportActionResult,
  ExportActionResultFromJSON,
  ExportActionResultToJSON,
  ExportDefectsPayload,
  ExportDefectsPayloadFromJSON,
  ExportDefectsPayloadToJSON,
  ExportEnqueueResult,
  ExportEnqueueResultFromJSON,
  ExportEnqueueResultToJSON,
  ExportIssuesPayload,
  ExportIssuesPayloadFromJSON,
  ExportIssuesPayloadToJSON,
  ExportRequirementsPayload,
  ExportRequirementsPayloadFromJSON,
  ExportRequirementsPayloadToJSON,
  ExportTestCasesPayload,
  ExportTestCasesPayloadFromJSON,
  ExportTestCasesPayloadToJSON,
  ForbiddenError,
  ForbiddenErrorFromJSON,
  ForbiddenErrorToJSON,
} from "../models";

export interface ExportDefectsRequest {
  exportDefectsPayload?: ExportDefectsPayload;
}

export interface ExportIssuesRequest {
  exportIssuesPayload?: ExportIssuesPayload;
}

export interface ExportRequirementsRequest {
  exportRequirementsPayload?: ExportRequirementsPayload;
}

export interface ExportTestCasesRequest {
  exportTestCasesPayload?: ExportTestCasesPayload;
}

/**
 * no description
 */
export class ExportApi extends runtime.BaseAPI {
  /**
   * Export the list of defects (in JSON format for CSV generation)
   * Export defects
   */
  async exportDefectsRaw(
    requestParameters: ExportDefectsRequest
  ): Promise<runtime.ApiResponse<ExportActionResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/defects/export`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExportDefectsPayloadToJSON(requestParameters.exportDefectsPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExportActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Export the list of defects (in JSON format for CSV generation)
   * Export defects
   */
  async exportDefects(
    requestParameters: ExportDefectsRequest
  ): Promise<ExportActionResult> {
    const response = await this.exportDefectsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Enqueues an asynchronous issue CSV export. The response returns a queueId that the client should poll via GET /queues/{id}. When the queue row reaches status 2, queue.results contains a `url` field pointing to the generated CSV file (the file is uploaded via the configured upload provider — S3 in production, local in development).
   * Enqueue an issue export
   */
  async exportIssuesRaw(
    requestParameters: ExportIssuesRequest
  ): Promise<runtime.ApiResponse<ExportEnqueueResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issues/export`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExportIssuesPayloadToJSON(requestParameters.exportIssuesPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExportEnqueueResultFromJSON(jsonValue)
    );
  }

  /**
   * Enqueues an asynchronous issue CSV export. The response returns a queueId that the client should poll via GET /queues/{id}. When the queue row reaches status 2, queue.results contains a `url` field pointing to the generated CSV file (the file is uploaded via the configured upload provider — S3 in production, local in development).
   * Enqueue an issue export
   */
  async exportIssues(
    requestParameters: ExportIssuesRequest
  ): Promise<ExportEnqueueResult> {
    const response = await this.exportIssuesRaw(requestParameters);
    return await response.value();
  }

  /**
   * Enqueues an asynchronous requirement CSV export. The response returns a queueId that the client should poll via GET /queues/{id}. When the queue row reaches status 2, queue.results contains a `url` field pointing to the generated CSV file.
   * Enqueue a requirement export
   */
  async exportRequirementsRaw(
    requestParameters: ExportRequirementsRequest
  ): Promise<runtime.ApiResponse<ExportEnqueueResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/requirements/export`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExportRequirementsPayloadToJSON(
        requestParameters.exportRequirementsPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExportEnqueueResultFromJSON(jsonValue)
    );
  }

  /**
   * Enqueues an asynchronous requirement CSV export. The response returns a queueId that the client should poll via GET /queues/{id}. When the queue row reaches status 2, queue.results contains a `url` field pointing to the generated CSV file.
   * Enqueue a requirement export
   */
  async exportRequirements(
    requestParameters: ExportRequirementsRequest
  ): Promise<ExportEnqueueResult> {
    const response = await this.exportRequirementsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Custom export the list of test cases (in JSON format)
   * Export test cases
   */
  async exportTestCasesRaw(
    requestParameters: ExportTestCasesRequest
  ): Promise<runtime.ApiResponse<ExportActionResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/testcases/export`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExportTestCasesPayloadToJSON(
        requestParameters.exportTestCasesPayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ExportActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Custom export the list of test cases (in JSON format)
   * Export test cases
   */
  async exportTestCases(
    requestParameters: ExportTestCasesRequest
  ): Promise<ExportActionResult> {
    const response = await this.exportTestCasesRaw(requestParameters);
    return await response.value();
  }
}
